// A total of 0 means unknown (reset on refinement delivery until monitoring restarts), like null.
export function alignerTotalSuffix(totalAligners: number | null | undefined): string {
    return totalAligners != null && totalAligners > 0 ? ` of ${totalAligners}` : '';
}
